<template>
  <div class="">
    <el-form :inline="true"  :model="list" status-icon ref="list" :rules="rules" label-width="100px" class="demo-ruleForm my">
        <el-form-item label="销售门店：" prop="storename" class="tinp tuitip">
          <el-input v-model="list.storename"  disabled></el-input>
        </el-form-item>
        <el-form-item label="制单人：" prop="billmakername" class="tinp tuitip">
          <el-input v-model="list.billmakername" disabled ></el-input>
        </el-form-item>
      <!-- <div class=" clear">  -->
        <el-form-item class="fr mingxibut">
          <el-button type="primary" class="" v-loading.fullscreen.lock="fullscreenLoading" @click="submitForm('list')">确认提交</el-button>
        </el-form-item>
        <el-form-item class="fr mingxibut">
          <el-button size="small" type="primary" style="width:40px;height: 38px" icon="el-icon-plus" @click="addList"></el-button>
        </el-form-item>
      <!-- </div>  -->
        <el-form-item label="备注：" class="tinp tuitip beizhuinp" style="width: 478px;margin-left: 0px !important">
          <el-input v-model="list.memo" placeholder="请输入内容" prefix-icon="el-icon-edit" clearable ></el-input>
        </el-form-item>
      <!-- <div class="line"></div> -->
      <div class="tablebox">
        <div style="overflow-y: auto;max-height:654px">
         <table style="width:100%">
            <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">

                <th style="" v-for="head in tableHeads">{{ head.label }}</th>
                <th style="width:105px" >删除</th>
            </tr>
            <tr v-for="(item,index) in list.productList" :key="">
                <!-- <td style="border: 1px solid #56B8AA; height: 38px;width:120px">
                    <el-input style="width: 120px" class="tabinp" v-model="item.repertoryname" clearable ></el-input>
                </td> -->
                 <td style="border: 1px solid #56B8AA; height: 38px;width:180px">
<!--                    <el-input v-model="item.positionname" disabled></el-input>-->
<!--                   <el-select v-model="item.positionname"-->
<!--                    placeholder="选择货位" suffix-icon="el-icon-search" v-on:click.native="openselectmodel(index)" />-->
                   <!-- {{item.positionname}} -->
                   <!-- <span>{{item.positionname}}</span> -->
<!--                   <el-select @change="selectchange" filterable value-key="positioncode" v-model="item.positionname" clearable placeholder="请选择货位" style="width:100%;" auto-complete="off">-->
<!--                     <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>-->
<!--                   </el-select>-->
                   <el-select @change="selectchange" filterable value-key="positioncode" v-model="item.position" clearable placeholder="请选择货位" style="width:100%;" auto-complete="off">
                     <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
                   </el-select>
                </td>
                 <td style="border: 1px solid #56B8AA; height: 38px;width:240px">
                    <el-input style="width: 240px" class="tabinp"  suffix-icon="el-icon-search" v-model="item.productName"  v-on:click.native="openModel(item)"></el-input>
                 </td>
                 <td style="border: 1px solid #56B8AA; height: 38px;width:120px">
                    <span style="width:220px">{{item.productCode}}</span>
                 </td>
                <!--  <td style="border: 1px solid #56B8AA; height: 38px;width:120px">
                    <span style="width:220px">{{item.suppliername}}</span>
                 </td>   -->
                 <td style="border: 1px solid #56B8AA; height: 38px;width:120px">
                    <span style="width:220px">{{item.wlspec}}</span>
                 </td>
                 <td style="border: 1px solid #56B8AA; height: 38px;width:120px">
                   <span style="width:220px">{{item.wltype}}</span>
                 </td>
                 <td style="border: 1px solid #56B8AA; height: 38px;width:100px">
                  <span style="width:220px">{{item.cunitname}}</span>
                 </td>
                <!--  <td style="border: 1px solid #56B8AA; height: 38px;width:100px">
                   <span style="width:220px">{{item.nprice}}</span>
                 </td> -->
                 <td style="border: 1px solid #56B8AA; height: 38px;width:100px">
                   <el-input class="tabinp" type="number" v-model="item.nznum" clearable @blur="numdown(item.nznum)" @change="onParamChange(index)"></el-input>
                 </td>
                 <td style="border: 1px solid #56B8AA; height: 38px;width:190px">
                   <el-input class="tabinp" v-model="item.memo" clearable ></el-input>
                 </td>
                <td style="border: 1px solid #56B8AA; height: 38px">
                    <el-button size="mini" type="danger" :disabled="index==0&&list.productList.length==1"  @click="handleDelete(index)">删行</el-button>
                </td>
            </tr>
        </table>
      </div>
      </div>
    </el-form>

   <!-- model start -->
        <div class="model selectmodel"  v-show="modelShow">
            <div class="content">
                <div class="title">
                  <span class="fl" v-if="selectid == '3'">选择货位</span>
                  <span class="fl" v-else>选择供应商</span>
                  <span class="fr" @click="closemodel(1)"><i class="iconfont icon-guanbi"></i></span>
                </div>
                <div class="selectinput">
                    <el-form :inline="true" style="padding:10px">
                        <el-form-item class="" style="width:100%;margin: 0 !important" v-if="selectid=='1'">
                            <el-select @change="selectchange"  filterable value-key="suppliercode" v-model="supplier.suppliername" clearable placeholder="请选择供应商" style="width:100%;" auto-complete="off">
                              <el-option v-for="item in supplierList" :key="item.suppliercode" :label="item.suppliername" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                         <el-form-item class="" style="width:100%;margin: 0 !important" v-if="selectid=='3'">
                            <el-select @change="selectchange" filterable value-key="positioncode" v-model="position.positionname" clearable placeholder="请选择货位" style="width:100%;" auto-complete="off">
                              <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    <!-- model start -->

 <!-- model start -->
        <div class="model"  v-show="modelShow2">
            <div class="content">
                <div class="title">
                  <span class="fl">请选择商品</span>
                  <span class="fr" @click="closemodel(2)"><i class="iconfont icon-guanbi"></i></span>
                </div>
                <div class="procontent clearfix" style="padding: 0 20px">
                    <el-form :inline="true" class="demo-form-inline">
                          <el-form-item label="商品编码："  class="tinp">
                            <el-input v-model="serchpro.productCode" suffix-icon="el-icon-search" clearable @change="selectpro"></el-input>
                          </el-form-item>
                          <el-form-item label="商品名称："  class="tinp">
                            <el-input v-model="serchpro.productName" suffix-icon="el-icon-search" clearable @change="selectpro"></el-input>
                          </el-form-item>
                          <el-button type="primary" class="" size="small" icon="el-icon-search" @click="selectpro">搜索</el-button>
                    </el-form>
                    <div class="clearfix"  style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px;width:1080px;margin:0">
		                <div class="fl" style="width:62px;height:45px;line-height: 45px;text-align:center;">选择</div>
		                <div class="fl" style="width:213px;height:45px;line-height: 45px;text-align:center;">商品编码</div>
		                <div class="fl" style="width:406px;height:45px;line-height: 45px;text-align:center;">商品名称</div>
		                <div class="fl" style="width:133px;height:45px;line-height: 45px;text-align:center;">规格</div>
		                <div class="fl" style="width:133px;height:45px;line-height: 45px;text-align:center;">型号</div>
		                <!-- <div class="fl" style="width:214px;height:45px;line-height: 45px;text-align:center;">供应商</div> -->
		                <div class="fl" style="width:133px;height:45px;line-height: 45px;text-align:center;">单位</div>

		            </div>
		          <div class="productList" style="overflow-y: auto;overflow-x:hidden;width:1098px;height: auto;max-height:332px">
		            <table style="width:1081px">
                             <!--  <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
                                  <th style="border: 1px solid #56B8AA;">选择</th>
                                  <th style="" v-for="head in proTitle">{{ head.label }}</th>
                              </tr> -->
                              <tr v-for="(item,index) in productList2"  :id="index" :key="index">
                                  <td class="fir" style="color: #fff;border: 1px solid #56B8AA;">
                                      <div class="list-item-check">
                                        <span class="checkbox-btn item-check-btn" v-bind:class="{'checked':item.checked=='1'}" @click="choose2(index)">
                                        <span class="iconfont icon-duigou" style="font-size: 12px"></span>
                                        </span>
                                      </div>
                                  </td>
                                 <!--  <td v-for="head in proTitle" style="border: 1px solid #56B8AA; height: 38px" @click="choose(index)">
                                     {{item[head.key]}}
                                  </td> -->
                                   <td style="border: 1px solid #56B8AA;width:213px; height: 38px" @click="choose2(index)">
					                  {{item.materialcode}}
					                </td>
					                <td style="border: 1px solid #56B8AA;width:406px; height: 38px" @click="choose2(index)">
					                  {{item.materialname}}
					                </td>
					                <td style="border: 1px solid #56B8AA;width:133px; height: 38px" @click="choose2(index)">
					                  {{item.wlspec}}
					                </td>
					                <td style="border: 1px solid #56B8AA;width:133px; height: 38px" @click="choose2(index)">
					                  {{item.wltype}}
					                </td>
					                <!--  <td style="border: 1px solid #56B8AA;width:214px; height: 38px" @click="choose2(index)">
					                  {{item.suppliername}}
					                </td> -->
					                <td style="border: 1px solid #56B8AA;width:133px; height: 38px" @click="choose2(index)">
					                  {{item.measdocname}}
					                </td>
                              </tr>
                          </table>
                    </div>

                    <el-button type="primary" class="fr" size="small"  style="margin-top: 10px" @click="checkpro2">确定</el-button>
                </div>
               <!-- fenye start -->
        <div class="block" style="text-align: center;margin:0px auto ">
          <span>
            <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="propage"
              :page-size="prosize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="procount">
            </el-pagination>
            </span>
        </div>
        <!-- fenye end -->
            </div>
        </div>
    <!-- model start -->

    <!-- model start -->
    <div class="model" v-show="false">
      <div class="content clearfix">
        <div class="title">
          <span class="fl">请选择商品</span>
          <span class="fr" @click="closemodel(2)"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="procontent clearfix" style="padding: 0 20px">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="商品编码：" class="tinp">
              <el-input v-model="serchpro.productCode" suffix-icon="el-icon-search" @keyup.enter.native="selectProduct(index)" clearable @change="selectprochange(index)"></el-input>
            </el-form-item>
            <el-form-item label="商品名称：" class="tinp">
              <el-input v-model="serchpro.productName" suffix-icon="el-icon-search" @keyup.enter.native="selectProduct(index)" clearable @change="selectprochange(index)"></el-input>
            </el-form-item>
            <el-button type="primary" class="" size="small" icon="el-icon-search" @click="selectProduct(index)">搜索</el-button>
          </el-form>
          <div class="productList" style="overflow-y: auto;overflow-x:hidden;width:100%;height: auto;max-height:332px">
            <table style="width:100%">
              <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
                <th style="border: 1px solid #56B8AA;">选择</th>
                <th style="" v-for="head in proTitle">{{ head.label }}</th>
              </tr>
              <tr v-for="(item,index) in productList2" :id="index" :key="index">
                <td class="fir" style="color: #fff;border: 1px solid #56B8AA;">
                  <div class="list-item-check">
                    <span class="checkbox-btn item-check-btn" v-bind:class="{'checked':item.checked=='1'}" @click="choose(index)">
                                        <span class="iconfont icon-duigou" style="font-size: 12px"></span>
                    </span>
                  </div>
                </td>
                <td v-for="head in proTitle" style="border: 1px solid #56B8AA; height: 38px" @click="choose(index)">
                  {{item[head.key]}}
                </td>
              </tr>
            </table>
          </div>
          <el-button type="primary" class="fr" size="small" style="margin-top: 10px" @click="checkpro">确定</el-button>
        </div>
      <!-- fenye start -->
        <div class="block" style="text-align: center;margin:0px auto ">
          <span>
            <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="propage"
              :page-size="prosize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="procount">
            </el-pagination>
            </span>
        </div>
        <!-- fenye end -->
      </div>
    </div>
    <!-- model start -->

      <!-- model end -->
    <div class="" v-loading.fullscreen.lock="fullscreenLoading"></div>
  <!-- 弹窗 start -->
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>
  </div>
</template>
<script>
import { setCookie, getCookie, delCookie } from '../../../static/js/cookie.js'
export default {
  data() {
  	var validateStorename = (rule, value, callback) => { //调出门店规则
		      if (value === '') {
		        callback(new Error('门店不能为空'));
		      } else {
		        callback();
		      }
		};
	    var validateBillmakername = (rule, value, callback) => { //业务员规则
	      if (value === '') {
	        callback(new Error('制单人不能为空'));
	      } else {
	        callback();
	      }
	    };
    return {
      flag:false,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'',
      butmsg:'确认',
      butmsg2:'确认',
      methodName:'',
      utilpath:'',
      InterfacePath:'',
      fullscreenLoading:false,
      propage:1,
      prosize:20,
      procount:0,
      user:{},
      msg: '',
      proTitle: [
                {
                    label: '商品编码',
                    key: 'materialcode'
                },
                {
                    label: '商品名称',
                    key: 'materialname'
                },
                {
                    label: '规格',
                    key: 'wlspec'
                },
                {
                    label: '型号',
                    key: 'wltype'
                },
                {
                    label: '供应商',
                    key: 'suppliername'
                },

                // {
                //     label: '单价',
                //     key: 'nprice'
                // },
                {
                    label: '单位',
                    key: 'cunitname'
                }
            ],
      selectid:'1',
      modelShow: false,
      modelShow2: false,
      list: {
        storecode: '',//退货门店
        storename: '',//退货门店
        billmakercode: '',//制单人
        billmakername: '',//制单人
        suppliercode:'',//供应商编码
        suppliername:'',//供应商名称
        couriername:'',//快递公司
        couriernumber:'',//快递单号
        telephone:'',//联系电话
        memo: '',//备注
        productList: [{//产品列表
          repertorycode: '',
          repertoryname: '',
          positioncode: '',
          position:'',
          positionname: '',
          productName: '',//商品名
          productCode: '',//商品编码
          wlspec: '',//规格
          wltype: '',//型号
          cunitcode: '',//单位编码
          cunitname: '',//单位值
          vbatchcode: '',//批次号
          nznum: '',//退货数量
          nprice: '',//退货数量
          ntaxmny: '',//本币价税合计
        }]
      },
      positions:{
          positioncode: '',//货位编码
          positionname: ''//货位名称
      },
      serchpro:{
        storecode:'',
        positioncode:'',
        positionname:'',
        productCode:'',
        productName:'',
        pageflag:0,
        pageNum:1,
        pageSize:20,
      },
      productList2:[],
      tableListindex:0,
      position: {
          positioncode: '',//货位编码
          positionname: ''//货位名称
      },
      store: {
          storecode: '',//门店编码
          storename: ''//门店名称
      },
      supplier:{
        suppliercode:'',
        suppliername:'',
        telephone:''
      },
      supplierList:[],
      positionList:[],
      storeList:[],
      index:0,
      index2:'',
      productName:'',
      productCode:'',
      delIndex:'',
      index2List: [],
      tableHeads: [
                // {
                //     label: '退货仓库',
                //     key: 'repertoryname'
                // },
                {
                    label: '销售货位',
                    key: 'positionname'
                },
                {
                    label: '商品名称',
                    key: 'productName'
                },
                {
                    label: '商品编码',
                    key: 'productCode'
                },
                // {
                //     label: '供应商',
                //     key: 'suppliername'
                // },
                {
                    label: '规格',
                    key: 'wlspec'
                },
                {
                    label: '型号',
                    key: 'wltype'
                },
                {
                    label: '单位',
                    key: 'cunitname'
                },
                // {
                //     label: '批次号',
                //     key: 'vbatchcode'
                // },
                // {
                //     label: '单价',
                //     key: 'nprice'
                // },
                {
                    label: '销售数量',
                    key: 'nznum'
                },
                {
                    label: '备注',
                    key: 'memo'
                }
            ],

     rules: { //规则明细
        storename: [
          { required: true, trigger: 'blur', validator: validateStorename }//
        ],
        billmakername: [
          { required: true, trigger: 'blur', validator: validateBillmakername}//
        ]
      }
    }
  },
  destroyed (){
      sessionStorage.removeItem("destroyed");
      sessionStorage.removeItem("tuilist");
      sessionStorage.removeItem("productList2");
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  methods: {
   returnMsg(flag){
      this.modelFlag = false;
      if(flag){
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true}).then((res)=>{
                    if(res.data.status == '0'){

                    }else{
                      this.modelFlag = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.methodName = 'message';
                  this.msg = '获取接口失败'+err;
                  this.butflag =false;
                  this.butmsg='知道了';
                })
            }else if(this.methodName =='handleDelete'){
                if (this.list.productList.length > 1) {
                  this.list.productList.splice(this.delIndex, 1);
                }
                sessionStorage.setItem("tuilist",JSON.stringify(this.list));
            }else if(this.methodName =='tijiaoxiaoshou'){
              this.fullscreenLoading = true;
                var saleOut={
                  SaleOut:JSON.stringify(this.list),
                };
                this.$http.post(this.utilpath+'/insersaleOut',saleOut,{emulateJSON:true,_timeout:600}).then((res) => {
                // this.$http.post('/ktnapi/insertReturnbill',Returnbill,{emulateJSON:true}).then((res) => {
                // this.$http.post(this.InterfacePath+'/insertReturnbill',Returnbill,{emulateJSON:true}).then((res) => {
                    if(res.data.status == '0'){
                        this.fullscreenLoading = false;
                        this.index2List=[];
                        this.$message({
                          showClose: true,
                          message: '提交成功！',
                          type: 'succcess'
                        });
                        sessionStorage.removeItem("tuilist");
                       // console.log("提交后打印供应商："+JSON.stringify(this.supplierList));
                        this.list= {
                                    storecode: this.user.storecode,//门店
                                    storename: this.user.storename,//门店
                                    billmakercode: this.user.user_code,
                                    billmakername: this.user.user_name,
                                    suppliercode:'',//供应商编码
                                    suppliername:'',//供应商名称
                                    couriernumber:'',//快递单号
                                    telephone:'',//联系电话
                                    memo: '',//备注
                                    productList: [{//产品列表
                                      // repertorycode: 'test001',
                                      repertorycode: this.user.storehouse_code,
                                      // repertoryname: 'test001',
                                      repertoryname: this.user.storehouse_name,
                                      positioncode: this.positions.positioncode,
                                      positionname: this.positions.positionname,
                                      nprice:'',//本币含税单价
                                      productName: '',//商品
                                      productCode: '',//商品
                                      wlspec: '',//规格
                                      wltype: '',//型号
                                      cunitname: '',//单位
                                      cunitcode: '',//单位
                                      nznum: '',//申请数量
                                      ntaxmny: ''//本币价税合计
                                    }]
                          };
                    } else if(res.data.status == '9'){
                      this.fullscreenLoading =false;
                      this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else{
                      this.fullscreenLoading = false
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                    }

                }, (err) => {
                    this.fullscreenLoading = false;
                    this.modelFlag = true;
                    this.msgShow = false;
                    this.methodName = 'message';
                    this.msg = '连接新增销售订单接口失败';
                    this.butflag =false;
                    this.butmsg='知道了';
                });
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },
    choose2(index) {
     // console.log("-=-=-=-=-=-=-打印下标" + index);
      this.productList2[index].checked = this.productList2[index].checked == '1' ? '0' : '1';
      if(this.productList2[index].checked =='1'){
          var indexFlag = true;
          for(var j=0;j<this.index2List.length;j++){

              // this.index2List.forEach((item)=>{
                  if(this.index2List[j]==index){
                      indexFlag =false;
                      continue;
                  }
              // })
          }
         // console.log("打印indexFlag"+indexFlag);
          if(indexFlag){
              this.index2List.push(index);
          }
          // console.log("choose2打印this.index2List："+JSON.stringify(this.index2List));
      }else{
        for(var j=0;j<this.index2List.length;j++){

              // this.index2List.forEach((item)=>{
                  if(this.index2List[j]==index){
                      this.index2List.splice(j,1)
                  }
              // })
          }
      }
      if (this.productList2[index].checked == '1') {

        document.getElementById(index).style.backgroundColor = "#FFEFB7"
      } else {

        document.getElementById(index).style.backgroundColor = "#fff"
      }
    },
    checkpro2() {
      // console.log("_=-=-=-=-=" + this.index + "-=-=-=-=-=-" + this.index2);
      var index2Flag = true;
      var num=0
      this.index2List.forEach((item)=>{
      	 // console.log("打印item值："+item);
      	 // console.log("打印item值："+this.productList2[item]);
          if(this.productList2[item].checked == '1'){
              // index2Flag = false;
              num+=1;
          }
          // console.log("打印indexList："+item);
          // console.log("打印this.productList2[item].checked："+this.productList2[item].checked);
      });
       if(this.index2List.length>0){
      index2Flag = false;
      }
      // console.log("打印this.index2List："+JSON.stringify(this.index2List));
      if (index2Flag) {
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'message';
            this.msg = '请至少选择一件商品';
            this.butflag =false;
            this.butmsg='知道了';
        // this.$alert('请至少选择一件商品', '警告', {
        //   confirmButtonText: '确定'
        // });
      } else {
        var proflag = false;
        // this.conditions.productList.forEach((item)=>{
        //     this.index2List.forEach((item2)=>{
        //        if(this.productList2[item2].materialname == item.materialname){
        //             proflag = true;
        //         }
        //    });
        // })
         for(var i=0;i<this.list.productList.length;i++){
              for(var j=0;j<this.index2List.length;j++){
                  // this.index2List.forEach((item2)=>{
                    // console.log("进入this.index2List.forEach打印");
                    // console.log("打印item2下标："+this.index2List[j]+"this.productList2[item2].materialname:"+this.productList2[this.index2List[j]].materialname);
                    // console.log("打印i下标："+this.index2List[j]+"this.conditions.productList[i].materialname:"+this.conditions.productList[i].materialname);

                     if(this.productList2[this.index2List[j]].materialname == this.list.productList[i].productName){
                          proflag=true;
                          this.index2List.splice(j,1);
                      }
                     //  // if(this.productList2[item2].materialname == this.conditions.productList[i].materialname){
                     //      this.conditions.productList.splice(i,1);
                     //  }

                 // });
              }
         }
            // console.log("-=-==-=-=-=-=-打印商品信息" + JSON.stringify(this.productList2));
            // console.log("-=-==-=-=-=-=-this.index" +this.index);
                var index2Listlength =this.index2List.length;
                var index2Listnum=1
                this.index2List.forEach((item3)=>{
                    this.list.productList[this.list.productList.length-1].productName = this.productList2[item3].materialname;
                    this.list.productList[this.list.productList.length-1].productCode = this.productList2[item3].materialcode;
                    this.list.productList[this.list.productList.length-1].wlspec = this.productList2[item3].wlspec;
                    this.list.productList[this.list.productList.length-1].wltype = this.productList2[item3].wltype;
                    this.list.productList[this.list.productList.length-1].cunitcode = this.productList2[item3].measdoccode;
                    this.list.productList[this.list.productList.length-1].cunitname = this.productList2[item3].measdocname;
                    // this.conditions.productList[this.index].corigcurrencyid = this.productList2[this.index2].nprice;
                    this.list.productList[this.list.productList.length-1].ntaxratecode = this.productList2[item3].taxratecode;
                    this.list.productList[this.list.productList.length-1].ntaxratename = this.productList2[item3].taxratename;
                    this.list.productList[this.list.productList.length-1].suppliercode = this.productList2[item3].suppliercode;
                    this.list.productList[this.list.productList.length-1].suppliername = this.productList2[item3].suppliername;
                    this.list.productList[this.list.productList.length-1].nprice = this.productList2[item3].nprice;
              this.list.productList[this.list.productList.length-1].ntaxmny = this.productList2[item3].ntaxmny;
                    // console.log("this.conditions.productList.length-1"+(this.list.productList.length-1));
                   // console.log("index2Listnum<index2Listlength"+(index2Listnum<index2Listlength));
                    this.productList2[item3].checked =0;
                    if(index2Listnum<=index2Listlength){
                         this.addList();
                         index2Listnum+=1
                         // index2Listlength-=1;
                    }
                });
                this.modelShow2 = false;
                for(var g=0;g<this.productList2.length;g++){
                  this.productList2[g].checked=='0'
                  document.getElementById(g).style.backgroundColor = "#fff"
                }
                if(proflag){
                    this.$message({
                      showClose:true,
                      message:'已剔除选中的重复商品',
                      type:'succcess'
                    })
                }
      }
      this.serchpro.productName='';
      this.serchpro.productCode='';

      for(var ii=0;ii<this.productList2.length;ii++){
          this.productList2[ii].checked=0
      }
      this.productList2=[];
      this.propage=1;
      this.prosize=20;
      this.procount=0;
      this.index2List=[];
    },
    choose(index){
      this.productList2[index].checked= this.productList2[index].checked=='1'?'0':'1';
      for(var i=0;i<this.productList2.length;i++){
            if(i!=index){
                this.productList2[i].checked='0'
                document.getElementById(i).style.backgroundColor="#fff"
            }
      }
      if(this.productList2[index].checked=='1'){

          document.getElementById(index).style.backgroundColor="#FFEFB7"
      }else{

          document.getElementById(index).style.backgroundColor="#fff"
      }
      this.index2=index;
      // console.log("打印选择下标:"+this.index2)
    },
    checkpro(){
    //  console.log("1_this.index=-=-=-=-="+this.index+"-=-=-=-=-=-"+this.index2+"-this.index2=-=--=-=-=-="+this.index2);
     // console.log("1_=-=-=-=-=商品名称-=-=--=-=-=-="+this.productList2[this.index2].materialname);
      // console.log("1_=-=-=-=-=被赋值的下标-=-=--=-=-=-="+this.index);
      var flag = false;
      var numindex = '';
      if(this.productList2[this.index2].checked=='1'){
        // console.log("2_=-=-=-=-="+this.index+"-=-=-=-=-=-"+this.index2+"-=-=--=-=-=-="+this.productList2[this.index2].checked);
          for(var i=0;i<this.list.productList.length;i++){

            if(this.list.productList[i].productName == this.productList2[this.index2].materialname){
                numindex = i;
                flag = true;
            };
          };
          if(flag){
            // console.log("3_=-=-=-=-="+this.index+"-=-=-=-=-=-"+this.index2+"-=-=--=-=-=-="+this.productList2[this.index2].checked);
              this.list.productList[numindex].nznum= parseFloat(this.list.productList[numindex].nznum)+1;
              this.list.productList[numindex].ntaxmny=parseFloat(this.list.productList[numindex].nprice)+parseFloat(this.list.productList[numindex].ntaxmny);
              this.modelShow2 = false;
              this.productList2[this.index2].checked = '0';
          }else{
            // console.log("4_=-=-=-=-="+this.index+"-=-=-=-=-=-"+this.index2+"-=-=--=-=-=-="+this.productList2[this.index2].checked);
              this.list.productList[this.index].productName = this.productList2[this.index2].materialname;
              this.list.productList[this.index].productCode = this.productList2[this.index2].materialcode;
              this.list.productList[this.index].wlspec = this.productList2[this.index2].wlspec;
              this.list.productList[this.index].wltype = this.productList2[this.index2].wltype;
              this.list.productList[this.index].suppliercode = this.productList2[this.index2].suppliercode;
              this.list.productList[this.index].suppliername = this.productList2[this.index2].suppliername;
              this.list.productList[this.index].cunitcode = this.productList2[this.index2].measdoccode;
              this.list.productList[this.index].cunitname = this.productList2[this.index2].measdocname;
              this.list.productList[this.index].nprice = this.productList2[this.index2].nprice;
              this.list.productList[this.index].ntaxmny = this.productList2[this.index2].ntaxmny;
              this.list.productList[this.index].ntaxratecode = this.productList2[this.index2].taxratecode;
              this.list.productList[this.index].ntaxratevalue = this.productList2[this.index2].taxratename;
              this.productList2[this.index2].checked = '0';
          }
          this.productList2[this.index2].checked = '0';
          this.modelShow2 = false;
          this.serchpro.productName='';
          this.serchpro.productCode='';

      }else{
            this.modelFlag = true;
            this.msgShow = false;
            this.methodName = 'message';
            this.msg = '请至少选择一件商品';
            this.butflag2 =false;
            this.butmsg2='知道了';
      }
    },
    init() {
         this.user =  JSON.parse(window.localStorage.getItem("userInfo"));
        this.getpositions();
        this.getposition();

        var bigdata = JSON.parse(sessionStorage.getItem("tuilist"));
        if(bigdata != null){
            this.list = bigdata
           // console.log("非空");
        }else{
        //  console.log("空");
          // this.list.pk_dept = user.pk_dept;
          this.list.corpcode = this.user.corpcode;
          this.list.corpname = this.user.corpname;
          this.list.storecode = this.user.storecode;
          this.list.storename = this.user.storename;
          this.list.billmakercode = this.user.user_code;
          this.list.billmakername = this.user.user_name;
          this.list.productList[0].repertorycode =  this.user.storehouse_code;
          this.list.productList[0].repertoryname = this.user.storehouse_name;
          this.list.productList[0].positioncode = this.positions.positioncode;
          this.list.productList[0].positionname = this.positions.positionname;
          this.serchpro.positioncode=this.positions.positioncode;
          this.serchpro.positionname=this.positions.positionname;
          this.getsupplier();
        }
    },
    getpositions(){
              //获取数据接口
        var reqParam = {
          storecode:this.user.storecode,
          positioncode:'31'
        };
        //this.$http.get('api/position').then((res) => {
        this.$http.post(this.utilpath+'/selectStorespositioninfo',reqParam,{emulateJSON:true,_timeout:600}).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
                    if(res.data.status == '0'){
                        var positions=res.data.resultList;
                        // this.positionList=[];
                        this.positions=positions[0];
                      if (positions.memo != 0 && positions.memo != 2) {
                        this.list.productList[0].positioncode = this.positions.positioncode;
                        this.list.productList[0].positionname = this.positions.positionname;
                        this.serchpro.positioncode=this.positions.positioncode;
                        this.serchpro.positionname=this.positions.positionname;
                      }
                        // this.selectpro();
                    } else if(res.data.status == '9'){
                      this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else{
                      this.positionList = [];
                      // this.selectpro();
                    }
                  // console.log("获取的JSON数据"+JSON.stringify(res.result));
                }, (err) => {
                    // console.log(err);
                });
    },
    getposition(){
              //获取数据接口
        var reqParam = {
          storecode:this.user.storecode,
        };
        //this.$http.get('api/position').then((res) => {
        this.$http.post(this.utilpath+'/selectStorespositioninfo',reqParam,{emulateJSON:true,_timeout:600}).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
                    if(res.data.status == '0'){
                      let positions = res.data.resultList;
                      let tmpPositions = [];
                      for (var i = positions.length - 1; i > -1; i--) {
                        if (positions[i].memo == 0 || positions[i].memo == 2) {
                          continue;
                        }
                        tmpPositions.push({positionname: positions[i].positionname, positioncode: positions[i].positioncode
                        });
                      }
                      this.positionList = tmpPositions;
                    } else if(res.data.status == '9'){
                      this.fullscreenLoading =false;
                      this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else{
                      this.positionList = [];
                    }
                  // console.log("获取的JSON数据"+JSON.stringify(res.result));
                }, (err) => {
                    // console.log(err);
                });
    },
     getsupplier(){
              //获取数据接口
        var reqParam = {
          storecode:this.user.storecode
        };
        // this.$http.get('api/selectSupplier').then((res) => {
        this.$http.post(this.utilpath+'/selectSupplierInfo',reqParam,{emulateJSON:true,_timeout:600}).then((res) => {
        // this.$http.post('/ktnapi/selectSupplierInfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectSupplierInfo',reqParam,{emulateJSON:true}).then((res) => {
                    if(res.data.status == '0'){
                        var suppliers=res.data.resultList;
                        this.supplierList=[];
                        for(var i=suppliers.length-1;i>-1;i--){
                            this.supplierList.push({value:suppliers[i].suppliername,suppliercode:suppliers[i].suppliercode,telephone:suppliers[i].telephone});
                        }
                        // console.log("打印供应商"+JSON.stringify(this.supplierList));
                    } else if(res.data.status == '9'){
                      this.fullscreenLoading =false;
                      this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else{
                      this.supplierList = [];
                    }
                  // console.log("获取的JSON数据"+JSON.stringify(res.result));
                }, (err) => {
                    // console.log(err);
                });
    },
    handleSizeChange(val) {
    //  console.log(`每页 ${val} 条`);
      this.prosize = val;
      this.propage=1;
      // this.selectProduct();
     // console.log(this.prosize);
    },
    handleCurrentChange(val) {
     // console.log(`当前页: ${val}`);
      this.propage = val;
    //  console.log(this.propage);
      this.fullscreenLoading=true;
      this.selectProduct(this.index);
    },
    selectprochange(num){
        this.propage=1;
      	this.fullscreenLoading=true;
        this.selectProduct(num);
    },
   selectpro(){
          this.serchpro.storecode=this.user.storecode;
          this.serchpro.pageflag =0;
          this.serchpro.pageNum=this.propage;
          this.serchpro.pageSize=this.prosize;
          this.serchpro.positioncode=this.positions.positioncode;
          this.serchpro.positionname=this.positions.positionname;
         // console.log("dayin");
          // selectPresentSock

          this.$http.post(this.utilpath+'/selectPresentSockForProduct',this.serchpro,{emulateJSON:true,_timeout:600}).then((result) => {
          	this.index2List =[];
          // this.$http.post(this.utilpath+'/selectAllSpdirectory',this.serchpro,{emulateJSON:true,_timeout:600}).then((result) => {
           // this.$http.post("/ktnapi/selectAllSpdirectory",this.serchpro,{emulateJSON:true}).then((result) => {
           // this.$http.post(this.InterfacePath+"/selectAllSpdirectory",this.serchpro,{emulateJSON:true}).then((result) => {
           // console.log();
                var res = result.data;
               // console.log("------------res.status:"+res.status+",res.message:"+res.message);
                if(res.status == '0'){
                  this.fullscreenLoading= false;
                     this.productList2=res.resultList;
                     this.productName = this.serchpro.productName;
                     this.productCode = this.serchpro.productCode;
                     if(this.serchpro.productName!=''||this.serchpro.productName!=null||this.serchpro.productCode!=''||this.serchpro.productCode!=null){

                     sessionStorage.setItem("productList2",JSON.stringify(this.productList2));
                     }
                     this.procount=res.countNum;
                     // console.log("_+_+_+_+_"+JSON.stringify(this.productList2));
                } else if(res.status == '9'){
                  this.fullscreenLoading =false;
                  this.$router.push({path:'/ui/login',query:{msg:9}});
                } else if(res.status == '-1'){
                  this.productList2=[];
                  sessionStorage.setItem("productList2",JSON.stringify(this.productList2));
                  this.fullscreenLoading= false;
                  this.msgShow = true;
                  this.modelFlag = true;
                  this.methodName = 'message';
                  this.msg = '当前货位无商品';
                  this.butflag =false;
                  this.butmsg='知道了';
                }else{
                  this.productList2=[];
                  sessionStorage.setItem("productList2",JSON.stringify(this.productList2));
                  this.fullscreenLoading= false;
                  this.msgShow = true;
                  this.modelFlag = true;
                  this.methodName = 'message';
                  this.msg = res.message;
                  this.butflag =false;
                  this.butmsg='知道了';
                }
            }, (err) => {
              this.fullscreenLoading= false;
              this.modelFlag = true;
              this.msgShow = false;
              this.methodName = 'message';
              this.msg = '连接查询商品接口失败';
              this.butflag =false;
              this.butmsg='知道了';
            });
    },
    selectProduct(num){

      // console.log("-=-=-=-=-==-"+JSON.stringify(this.serchpro));
      this.index=num==null?this.index:num;
      // this.fullscreenLoading= true;
      // this.modelShow2 = true;
     // console.log("打印选中行数据："+JSON.stringify(this.list.productList[num]));
     //  this.positions.positioncode=this.list.productList[num].positioncode;
     //  this.positions.positionname=this.list.productList[num].positionname;
      // if(this.productList2.length>0){
      this.selectpro();
      // }
    },
    openModel(item){
    	if(this.productList2.length<=50){
    		// this.fullscreenLoading= true;
    		 // this.selectpro();
    	}
      this.positions.positioncode=item.position.positioncode;
      this.positions.positionname=item.position.positionname;
      this.serchpro.positioncode=item.position.positioncode;
      this.serchpro.positionname=item.position.positionname;
    	this.modelShow2 = true;
    },
     getstore(){
              //获取数据接口
                this.$http.post(this.utilpath+'/selectStore',{emulateJSON:true,_timeout:600}).then((res) => {
                // this.$http.post('/ktnapi/selectStore',{emulateJSON:true}).then((res) => {
                // this.$http.post(this.InterfacePath+'/selectStore',{emulateJSON:true}).then((res) => {
                    if(res.data.status == '0'){
                        var stores=res.data.resultList;
                        this.storeList=[];
                        for(var i=stores.length-1;i>-1;i--){
                            this.storeList.push({storename:stores[i].storename,storecode:stores[i].storecode});
                        }
                       // console.log("打印货位"+JSON.stringify(this.storeList));
                    } else if(res.data.status == '9'){
                      this.fullscreenLoading =false;
                      this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else{
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                    }

                }, (err) => {
                    this.modelFlag = true;
                    this.msgShow = false;
                    this.methodName = 'message';
                    this.msg = '连接查询门店接口失败';
                    this.butflag =false;
                    this.butmsg='知道了';
                });
    },
    selectchange(value){
              //  console.log("下拉变化事件1"+JSON.stringify(value)+"下标：");
                // console.log("下拉变化事件1"+JSON.stringify(this.store)+"下标：");
                // console.log("下拉变化事件2"+value.positioncode);
                if(this.selectid == '1'){
                    this.list.suppliercode= value.suppliercode;
                    this.list.suppliername= value.suppliername;
                    this.list.telephone= value.telephone;
                    this.modelShow = false;
                    this.supplier={
                      suppliercode: '',
                      suppliername: ''
                    };
                }else{
                	this.productList2=[];
                    this.serchpro.positioncode = value.positioncode;
                    this.positions.positioncode= value.positioncode;
                    this.serchpro.positionname = value.positionname;
                    this.positions.positionname = value.positionname;
                    this.list.productList[this.tableListindex].positioncode = value.positioncode;
                    this.list.productList[this.tableListindex].positionname = value.positionname;
                    // this.list.productList.forEach((item)=>{
                    //     console.log("打印："+JSON.stringify(item));
                    // });
                    sessionStorage.setItem("tuilist",JSON.stringify(this.list));
                    this.modelShow = false;
                    this.position={
                        positioncode: '',
                        positionname: ''
                    };
                    this.index2List=[];
                    this.selectProduct(this.index);
                }

    },
    openselectmodel(index){
        // console.log("model内打印："+index);
      if(index==-3){
        this.modelShow = true;
        this.selectid = "1"
        this.getsupplier();
      }else{
        this.tableListindex = index;
        this.selectid = "3"
        this.modelShow = true;
        this.getposition();
        this.index=index;
      }
    },
    closemodel(num){
      if(num=='1'){
        this.modelShow = false;
      }else{
        this.modelShow2 = false;
        this.index='';
        this.index2='';
        this.serchpro.productName='';
        this.serchpro.productCode='';
        for(var g=0;g<this.productList2.length;g++){
          this.productList2[g].checked=='0'
          document.getElementById(g).style.backgroundColor = "#fff"
        }
      }
    },

    addList() { //添加明细
      var lis = {
          repertorycode: this.user.storehouse_code,
          repertoryname: this.user.storehouse_name,
          positioncode: this.positions.positioncode,
          positionname: this.positions.positionname,
          nprice:'',//本币含税单价
          productName: '',//商品
          productCode: '',//商品
          suppliercode: '',//供应商
          suppliername: '',//供应商
          wlspec: '',//规格
          wltype: '',//型号
          cunitname: '',//单位
          cunitcode: '',//单位
          nznum: '',//申请数量
          ntaxmny: ''//本币价税合计
      }
      this.list.productList.push(lis);
      sessionStorage.setItem("tuilist",JSON.stringify(this.list));
    },
     //搜索框变化事件
    onParamChange(index) {
      sessionStorage.setItem("tuilist",JSON.stringify(this.list));
      if(index!=null){
        this.list.productList[index].ntaxmny=parseFloat(this.list.productList[index].nprice) * parseFloat(this.list.productList[index].nznum);
      }
    },
    handleDelete(index) { //删除数据
      this.delIndex = index;
      this.methodName = 'handleDelete';
      this.modelFlag = true;
      this.msgShow = false;
      this.butflag = true;
      this.butmsg='确认';
      this.msg = '此操作将删除该行，是否继续？'
    },
     numdown(num){
        if(num<0){
          this.$message({
            showClose: true,
            message: '数量不能为负数！',
            type: 'error'
          });
        }
    },
    submitForm(formName) { //提交表单
      var reqParams = this.list;
     // console.log("测试list是否为空"+JSON.stringify(this.list));
      // console.log("测试调出门店是否为空"+this.list.storename);
      this.$refs[formName].validate((valid) => {
        if (valid) {//符合规则
              var flag = true;
              var flag2 = false;
              var lastnum=this.list.productList.length-1
            if(this.list.productList[lastnum].productCode==''||this.list.productList[lastnum].productName==''||this.list.productList[lastnum].productCode==null||this.list.productList[lastnum].productName==null){
              if(lastnum!=0 ){

              this.list.productList.splice(lastnum,1)
              }
             //  console.log("删除多余行lastnum"+lastnum);
            }
              this.list.productList.forEach((item) => {//遍历数据判断数据是否符非空
                    if (item.repertorycode === '' ||  item.productName === '' || item.nznum === '') {
                      this.$message({
                        showClose: true,
                        message: '请将明细表填写完整！',
                        type: 'error'
                      });
                      // console.log("index:" + JSON.stringify(item));
                      flag = false;
                      return;
                    }
                    // if(this.list.suppliercode==null||this.list.suppliercode==''){
                    //    this.$message({
                    //     showClose: true,
                    //     message: '请在供应商名称处输入存在的供应商，然后点选供应商再提交！',
                    //     type: 'error'
                    //   });
                    //   // console.log("index:" + JSON.stringify(item));
                    //   flag = false;
                    //   return;
                    // }
                    if(item.nznum<0){
                        flag2 = true;
                    }
              });
              if (!flag&&!flag2) {
                return;
              } else if(flag2){
                this.$message({
                  showClose:true,
                  message:'数量不能为负数！',
                  type:'info'
                })
              }else {
                this.methodName='tijiaoxiaoshou'
                this.modelFlag = true;
                this.msgShow = false;
                this.msg = '确定提交销售单？';
                this.butflag = true;
                this.butmsg='确认';
              }
        } else {
          this.fullscreenLoading = false;
          this.$message({
            showClose: true,
            message: '提交失败！',
            type: 'error'
          });
          return false;
        }

      });
    }
  }
}

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/stock/zengxiao.vue